(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }
  function inWindow(element) {
    var now = Math.floor(Date.now() / 1000);
    var start = Number(element.dataset.gbStart || 0), end = Number(element.dataset.gbEnd || 0);
    return start <= now && (!end || now < end);
  }
  function refreshPage(page) {
    var rows = Array.from(page.querySelectorAll('[data-gb-item]')).sort(function (a, b) { return Number(a.dataset.gbIndex) - Number(b.dataset.gbIndex); });
    var available = page.dataset.gbLive !== 'false' && inWindow(page), msrp = 0;
    var ids = rows.map(function (row) {
      var picker = row.querySelector('[data-gb-variant-picker]');
      var option = picker && picker.selectedOptions[0];
      var price = Number(option ? option.dataset.price : row.dataset.gbValue);
      msrp += price;
      if (option && option.dataset.available !== 'true') available = false;
      var value = row.querySelector('[data-gb-item-value]');
      var template = row.querySelector('[data-gb-value-template]');
      if (value && template) value.innerHTML = template.dataset.gbValueTemplate.replace('[amount]', formatMoney(price));
      var itemPrice = row.querySelector('[data-gb-item-price]');
      if (value && itemPrice) value.hidden = price <= Number(itemPrice.dataset.gbItemPrice);
      return option ? option.value : row.dataset.gbVariant;
    });
    if (!rows.length) msrp = Number(page.dataset.gbDefaultMsrp || 0);
    var form = page.querySelector('[data-gb-bundle-form]');
    if (form) {
      if (rows.length) form.elements['properties[_gb_bundle_variants]'].value = ids.join(',');
      var button = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
      button.disabled = !available || form.dataset.gbBusy === 'true';
      var label = button.querySelector('[data-add-to-cart-text]');
      if (label) {
        var textNode = Array.from(label.childNodes).filter(function (node) { return node.nodeType === 3; }).pop();
        if (textNode) textNode.textContent = ' ' + (available ? page.dataset.gbAddText : page.dataset.gbSoldText);
      }
    }
    var price = Number(page.dataset.gbPrice);
    var compare = page.querySelector('[data-gb-msrp]');
    if (compare) { compare.innerHTML = formatMoney(msrp); compare.hidden = msrp <= price; }
    var badge = page.querySelector('[data-gb-badge]');
    if (badge) {
      badge.hidden = msrp <= price;
      var percentOffTemplate = badge.dataset.percentOffTemplate;
      if (percentOffTemplate) {
        badge.textContent = msrp > price ? percentOffTemplate.replace('__PERCENT__', String(Math.round((msrp - price) * 100 / msrp))) : '';
      } else {
        var saving = page.dataset.gbSaveType === 'currency_amount' ? formatMoney(msrp - price).replace(/\.00\b/, '') : String(Math.round((msrp - price) * 100 / msrp)) + '%';
        badge.textContent = msrp > price ? page.dataset.gbSave + ' ' + saving : '';
      }
    }
    var priceDiv = page.querySelector('#priceDiv');
    if (priceDiv) priceDiv.dataset.compare = String(msrp);
    return available;
  }
  async function add(source, id, handle, variants) {
    var container = source.closest('[data-gb-bundle-card], [data-gb-bundle-form]');
    if (!container || source.dataset.gbBusy === 'true') return;
    var error = container.querySelector('[data-gb-error]');
    if (!inWindow(container)) { if (error) error.textContent = window.gbBundleText.unavailable; return; }
    source.dataset.gbBusy = 'true'; source.disabled = true; source.setAttribute('aria-busy', 'true');
    if (error) error.textContent = '';
    try {
      var response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _gb_bundle: handle, _gb_bundle_variants: variants } }] }) });
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || window.gbBundleText.failed);
      document.dispatchEvent(new CustomEvent('cart:build'));
      var opener = document.querySelector('.js-drawer-open-cart');
      if (opener) opener.click(); else document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (failure) { if (error) error.textContent = failure.message || window.gbBundleText.failed; }
    finally { source.dataset.gbBusy = 'false'; source.disabled = !inWindow(container); source.setAttribute('aria-busy', 'false'); }
  }
  function init(scope) {
    scope.querySelectorAll('[data-gb-page]').forEach(refreshPage);
    scope.querySelectorAll('[data-gb-gallery]').forEach(function (gallery) {
      if (gallery.closest('[data-section-type="product-template"]') || gallery.dataset.gbReady || !(window.theme && theme.Slideshow)) return;
      var slider = gallery.querySelector('[data-product-photos]');
      if (slider.children.length > 1) new theme.Slideshow(slider, { initialIndex: 0, adaptiveHeight: true, childNav: gallery.querySelector('[data-product-thumbs]'), childNavScroller: gallery.querySelector('[data-product-thumbs-scroller]'), childVertical: false, fade: true, pageDots: true, wrapAround: true });
      gallery.dataset.gbReady = 'true';
    });
  }
  document.addEventListener('change', function (event) { var page = event.target.closest('[data-gb-page]'); if (page) refreshPage(page); });
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-gb-bundle-form]');
    if (!form || !form.dataset.gbBundleForm) return;
    if (form.dataset.gbThemeForm) {
      var page = form.closest('[data-gb-page]');
      if (!refreshPage(page)) { event.preventDefault(); event.stopImmediatePropagation(); }
      return;
    }
    event.preventDefault();
    add(form.querySelector('button[type="submit"]'), form.elements.id.value, form.dataset.gbHandle, form.elements['properties[_gb_bundle_variants]'].value);
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gb-add]');
    if (!button) return;
    event.preventDefault();
    add(button, button.dataset.gbId, button.dataset.gbHandle, button.dataset.gbVariants);
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    document.querySelectorAll('[data-gb-cart-offers] [data-gb-bundle-card]').forEach(function (card) {
      card.hidden = cart.items.some(function (line) { return String(line.variant_id) === card.dataset.gbParent || line.properties && line.properties._gb_bundle === card.dataset.gbBundleCard; });
    });
  });
  function checkDates() {
    document.querySelectorAll('[data-gb-bundle-card]').forEach(function (card) { if (!inWindow(card)) card.hidden = true; });
    document.querySelectorAll('[data-gb-page]').forEach(refreshPage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); checkDates(); });
  else { init(document); checkDates(); }
  window.setInterval(checkDates, 15000);
})();
